export let FilterType = /*#__PURE__*/function (FilterType) {
  FilterType["CustomerName"] = "company";
  FilterType["AgreementName"] = "agreement";
  FilterType["ServiceName"] = "service";
  return FilterType;
}({});